
define('tmpl!core/templates/webidl-contiguous/line-comment.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlSectionComment\'>{{idn indent}}//{{comment}}</span>\n');});

